import { render, staticRenderFns } from "./CopyStakeAiStreamersTab.vue?vue&type=template&id=741599ab&scoped=true&lang=pug"
import script from "./CopyStakeAiStreamersTab.vue?vue&type=script&lang=ts"
export * from "./CopyStakeAiStreamersTab.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeAiStreamersTab.vue?vue&type=style&index=0&id=741599ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741599ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow})
